import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { InputSwitchModule } from '../components/input-switch/input-switch.module';
import { OptionType } from '../core/enums/enums';
import { SharedModule } from '../shared/shared.module';
import { BreadcumbComponent } from './components/breadcumb/breadcumb.component';
import { ErrorModalComponent } from './components/error-modal/error-modal.component';
import { HeaderComponent } from './components/header/header.component';
import { DefaultBreadcumbComponent } from './default-breadcumb/default-breadcumb.component';
import { DefaultComponent } from './default/default.component';
import { LayoutEffects } from './effects/layout.effects';
import { reducer } from './reducers/layout.reducer';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { ReactiveFormsModule } from '@angular/forms';
import { AlertModule, RemarksModule } from '../components';
import { SettingsModule } from '../settings/settings.module';
import { ExchangeOverrideModule } from '../exchange-override/exchange-override.module';
import { BookingCredentialsModule } from '../components/booking-credentials/booking-credentials.module';
import { IntegrationsService } from '../integrations/services/integrations.service';
import {
  ModalModule,
  InputFieldModule,
  InputSubmitModule,
  SpinnerModule,
  CheckBoxModule,
  TinyAlertModule
} from '../components';

@NgModule({
  declarations: [
    DefaultComponent,
    HeaderComponent,
    DefaultBreadcumbComponent,
    BreadcumbComponent,
    ErrorModalComponent,
    ChangePasswordComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
    ModalModule,
    InputFieldModule,
    InputSubmitModule,
    ReactiveFormsModule,
    InputSwitchModule,
    BookingCredentialsModule,
    StoreModule.forFeature(OptionType.Layout, reducer),
    EffectsModule.forFeature([LayoutEffects]),
    MatIconModule,
    MatTooltipModule,
    AlertModule,
    SettingsModule,
    SpinnerModule,
    ExchangeOverrideModule,
    CheckBoxModule,
    TinyAlertModule,
    RemarksModule
  ],
  exports: [DefaultComponent, DefaultBreadcumbComponent],
  providers: [IntegrationsService]
})
export class LayoutModule {}
